import React from 'react';
import PropTypes from 'prop-types';
import withConfig from 'config/withConfig';
import SpotDetailsDirectionsMap from '../map/SpotDetailsDirectionsMap';
import SpotDetailsPanelMap from '../map/SpotDetailsPanelMap';

export const FacilityLocation = ({isMobile, facility, distanceInMiles}) => {
    const {
        latitude,
        longitude,
        airport: {
            details: {
                latitude: destinationLatitude,
                longitude: destinationLongitude,
            },
        },
        addresses,
    } = facility;

    return (
        <div className="FacilityLocation">
            <h4 className="subtitle">Facility Location</h4>
            {isMobile ? (
                <SpotDetailsPanelMap
                    spotLatitude={latitude}
                    spotLongitude={longitude}
                    destinationLatitude={destinationLatitude}
                    destinationLongitude={destinationLongitude}
                    isDriving
                    isDraggable
                />
            ) : (
                <SpotDetailsDirectionsMap
                    spotLatitude={latitude}
                    spotLongitude={longitude}
                    destinationLatitude={destinationLatitude}
                    destinationLongitude={destinationLongitude}
                    isDriving
                    isDraggable
                />
            )}
            <div className="FacilityLocation-address-distance">
                <span className="address">{addresses[0].street_address}</span>
                <span className="distance">
                    Driving Distance: {Number(distanceInMiles).toFixed(1)} miles
                </span>
            </div>
        </div>
    );
};

FacilityLocation.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    facility: PropTypes.object.isRequired,
    distanceInMiles: PropTypes.number,
};

export default withConfig(['isMobile'])(FacilityLocation);
